/* ==========================================================================
   VITAL VIAL - Product page
   Gallery, hotspots, lightbox, variant matching, quantity, add-to-cart,
   share, modals. Variant changes update URL, price, stock and media.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Gallery ---------------------------------------------------- */
  function initGallery() {
    var gallery = document.querySelector('[data-vv-gallery]');
    if (!gallery || gallery.dataset.vvBound === '1') return;
    gallery.dataset.vvBound = '1';

    var slides = gallery.querySelectorAll('[data-vv-slide]');
    var thumbs = gallery.querySelectorAll('[data-vv-thumb]');

    function show(index) {
      slides.forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-vv-slide') === String(index));
      });
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', String(t.getAttribute('data-vv-thumb') === String(index)));
      });
      gallery.querySelectorAll('[data-vv-hotspot]').forEach(function (h) {
        h.hidden = h.getAttribute('data-slide') !== String(index);
        h.classList.remove('is-open');
      });
      // Pause any video that scrolled out of the active slide
      gallery.querySelectorAll('.vv-gallery__slide:not(.is-active) video').forEach(function (v) { v.pause(); });
    }
    window.vvGalleryShow = show;
    show(0);

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-vv-thumb'), 10)); });
    });

    /* Hover zoom */
    if (gallery.dataset.zoom === 'true' && !reduceMotion) {
      var stage = gallery.querySelector('[data-vv-gallery-stage]');
      stage.addEventListener('mousemove', function (e) {
        var img = stage.querySelector('.vv-gallery__slide.is-active img');
        if (!img) return;
        var r = stage.getBoundingClientRect();
        img.style.transformOrigin =
          ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        img.style.transform = 'scale(1.6)';
      });
      stage.addEventListener('mouseleave', function () {
        var img = stage.querySelector('.vv-gallery__slide.is-active img');
        if (img) { img.style.transform = ''; img.style.transformOrigin = ''; }
      });
    }

    /* Hotspots */
    var hotToggle = gallery.querySelector('[data-vv-hotspots-toggle]');
    var hotLayer = gallery.querySelector('[data-vv-hotspots]');
    if (hotToggle && hotLayer) {
      hotToggle.addEventListener('click', function () {
        var on = hotLayer.classList.toggle('is-on');
        hotToggle.setAttribute('aria-pressed', String(on));
        hotToggle.classList.toggle('is-active', on);
        if (!on) hotLayer.querySelectorAll('.is-open').forEach(function (h) { h.classList.remove('is-open'); });
      });
    }
    gallery.addEventListener('click', function (e) {
      var dot = e.target.closest('.vv-hotspot__dot');
      if (!dot) return;
      var spot = dot.closest('[data-vv-hotspot]');
      var open = spot.classList.contains('is-open');
      gallery.querySelectorAll('[data-vv-hotspot]').forEach(function (h) { h.classList.remove('is-open'); });
      gallery.querySelectorAll('.vv-hotspot__dot').forEach(function (d) { d.setAttribute('aria-expanded', 'false'); });
      if (!open) { spot.classList.add('is-open'); dot.setAttribute('aria-expanded', 'true'); }
    });

    /* Lightbox */
    var lb = document.querySelector('[data-vv-lightbox]');
    if (lb) {
      var lbImg = lb.querySelector('[data-vv-lightbox-img]');
      gallery.addEventListener('click', function (e) {
        if (!e.target.closest('[data-vv-lightbox-open]')) return;
        var img = gallery.querySelector('.vv-gallery__slide.is-active img');
        if (!img) return;
        lbImg.src = img.currentSrc || img.src;
        lbImg.alt = img.alt || '';
        lb.classList.add('is-open');
        lb.setAttribute('aria-hidden', 'false');
        document.body.classList.add('vv-no-scroll');
      });
      function closeLb() {
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('vv-no-scroll');
      }
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-vv-lightbox-close]') || e.target === lb) closeLb();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb();
      });
    }
  }

  /* ---------- Variants --------------------------------------------------- */
  function initVariants() {
    var form = document.querySelector('[data-vv-product-form]');
    if (!form || form.dataset.vvBound === '1') return;
    form.dataset.vvBound = '1';

    var dataEl = document.querySelector('[data-vv-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-vv-variant-id]');
    var priceEl = document.querySelector('[data-vv-price]');
    var stockEl = document.querySelector('[data-vv-stock]');
    var addBtn = form.querySelector('[data-vv-add-to-cart]');
    var addText = form.querySelector('[data-vv-add-text]');

    function selected() {
      var vals = [];
      form.querySelectorAll('[data-vv-option-input]:checked').forEach(function (i) {
        vals[parseInt(i.getAttribute('data-option-index'), 10)] = i.value;
      });
      return vals;
    }

    function match(vals) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      });
    }

    function updateAvailability(vals) {
      // Grey out option values that cannot combine with the current selection
      form.querySelectorAll('[data-vv-option-input]').forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var probe = vals.slice();
        probe[idx] = input.value;
        var exists = variants.some(function (v) {
          return v.available && v.options.every(function (o, i) {
            return i === idx ? o === input.value : (vals[i] == null || o === vals[i]);
          });
        });
        input.disabled = !exists;
      });
    }

    function update() {
      var vals = selected();
      var variant = match(vals);
      updateAvailability(vals);

      vals.forEach(function (val, i) {
        var label = form.querySelector('[data-vv-option-selected="' + i + '"]');
        if (label) label.textContent = val;
      });

      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = addBtn ? (addBtn.getAttribute('data-unavailable') || 'Unavailable') : '';
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        priceEl.innerHTML = variant.compare_at_price > variant.price
          ? '<span style="color:var(--vv-gold-deep);">' + variant.price_formatted + '</span><s>' + variant.compare_formatted + '</s>'
          : '<span>' + variant.price_formatted + '</span>';
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addText) {
          addText.textContent = variant.available
            ? (addBtn.getAttribute('data-label-add') || addText.dataset.add || addText.textContent)
            : 'Sold out';
        }
      }

      if (stockEl) {
        var state = 'in';
        if (!variant.available) state = 'out';
        else if (variant.inventory_management && variant.inventory_policy === 'deny' &&
                 variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) state = 'low';
        stockEl.setAttribute('data-stock', state);
      }

      if (variant.featured_media_id && window.vvGalleryShow) {
        var slide = document.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (slide) window.vvGalleryShow(parseInt(slide.getAttribute('data-vv-slide'), 10));
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());

      if (window.vvBus) window.vvBus.emit('variant:changed', variant);
    }

    // Preserve the server-rendered add-to-cart label for re-use
    if (addText && addBtn) addBtn.setAttribute('data-label-add', addText.textContent.trim());

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-vv-option-input]')) update();
    });
    update();
  }

  /* ---------- Quantity --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vv-qty]');
    if (!btn) return;
    var input = btn.closest('.vv-qty').querySelector('[data-vv-qty-input]');
    var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-vv-qty'), 10);
    input.value = Math.max(parseInt(input.min, 10) || 1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Add to cart (AJAX) ----------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"], [data-vv-product-form] form');
    if (!form) return;
    var btn = form.querySelector('[type="submit"]');
    e.preventDefault();

    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || 'Could not add to cart');
        if (btn) {
          btn.innerHTML = '<span>Added</span>';
          setTimeout(function () { btn.innerHTML = original; btn.disabled = false; btn.style.opacity = ''; }, 1600);
        }
        if (window.vvBus) window.vvBus.emit('cart:updated', res.data);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) {
        if (btn) { btn.innerHTML = original; btn.disabled = false; btn.style.opacity = ''; }
        console.warn('[vv] add to cart failed:', err.message);
        // Fall back to a real form post so the customer is never stuck
        form.setAttribute('data-vv-bypass', '1');
        HTMLFormElement.prototype.submit.call(form);
      });
  });

  /* ---------- Generic modals --------------------------------------------- */
  var modalRelease = null, modalOpener = null;
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-vv-modal-open]');
    if (open) {
      e.preventDefault();
      var modal = document.querySelector('[data-vv-modal="' + open.getAttribute('data-vv-modal-open') + '"]');
      if (!modal) return;
      modalOpener = open;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('vv-no-scroll');
      var panel = modal.querySelector('.vv-modal__panel');
      if (window.vvTrapFocus) modalRelease = window.vvTrapFocus(panel, function () { closeModal(modal); });
      return;
    }
    var close = e.target.closest('[data-vv-modal-close]');
    if (close) { e.preventDefault(); closeModal(close.closest('[data-vv-modal]')); }
  });

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vv-no-scroll');
    if (modalRelease) { modalRelease(); modalRelease = null; }
    if (modalOpener && modalOpener.focus) modalOpener.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-vv-modal].is-open');
    if (open) closeModal(open);
  });

  /* ---------- Share ------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vv-share]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-url');
    var title = btn.getAttribute('data-title');

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var old = btn.innerHTML;
        btn.textContent = 'Link copied';
        setTimeout(function () { btn.innerHTML = old; }, 1800);
      });
    }
  });

  /* ---------- Recently viewed ------------------------------------------- */
  function recordRecentlyViewed() {
    var handleMeta = document.querySelector('[data-vv-product-handle]');
    if (!handleMeta) return;
    var KEY = 'vv:recent:v1';
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      var h = handleMeta.getAttribute('data-vv-product-handle');
      list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 12);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function boot() { initGallery(); initVariants(); recordRecentlyViewed(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function () {
    var g = document.querySelector('[data-vv-gallery]');
    if (g) g.dataset.vvBound = '';
    var f = document.querySelector('[data-vv-product-form]');
    if (f) f.dataset.vvBound = '';
    boot();
  });
})();
